var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import RefreshCommand from './RefreshCommand';
import Session from '../../services/Session';
import History from '../../services/History';
import GetCurrentUserCommand from '../users/GetCurrentUserCommand';
/**
 *
 */
var ApplicationStartupCommand = /** @class */ (function (_super) {
    __extends(ApplicationStartupCommand, _super);
    function ApplicationStartupCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     */
    ApplicationStartupCommand.prototype.execute = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var command = new RefreshCommand();
            command.execute().catch(function (e) { return e; } /* ignore error, change is reflected in session */).finally(function () {
                // Get user details if logged in
                if (Session.hasToken) {
                    _this.getUser().catch(function (e) { return e; } /* ignore error, change is reflected in session */).finally(function () {
                        ApplicationStartupCommand.setInitialized();
                        resolve(undefined);
                    });
                }
                else {
                    ApplicationStartupCommand.setInitialized();
                    resolve(undefined);
                }
            });
        });
    };
    /**
     *
     */
    ApplicationStartupCommand.prototype.getUser = function () {
        var command = new GetCurrentUserCommand();
        return command.execute();
    };
    /**
     *
     */
    ApplicationStartupCommand.setInitialized = function () {
        Session.isInitialized = true;
        var deeplink = Session.getDeeplink(Session.isLoggedIn);
        if (deeplink) {
            History.push(deeplink);
        }
    };
    return ApplicationStartupCommand;
}(Command));
export default ApplicationStartupCommand;
